import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from './Card';
import { Button } from './Button';
import { Badge } from './Badge';
import { Check } from 'lucide-react';
const includes = ['Ebook completo', 'Plantilla profesional CV para yates', 'Checklist antes de aplicar', '50 preguntas reales de entrevistas', 'Guía rápida de inglés para chefs', 'Mapa paso a paso para conseguir tu primer embarque'];
export function Pricing() {
  return <section className="py-16 bg-background" id="planes" data-id="element-131">
      <div className="px-5" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative z-10 pt-4" data-id="element-133">
          <div className="absolute -top-1 left-1/2 -translate-x-1/2 z-20 text-center" data-id="element-134">
            <Badge className="bg-primary text-primary-foreground hover:bg-primary px-4 py-1 text-xs font-bold uppercase tracking-wider shadow-lg whitespace-nowrap" data-id="element-135">
              ⭐ OFERTA EXCLUSIVA
            </Badge>
          </div>

          <Card className="bg-secondary border-primary shadow-[0_0_40px_-10px_rgba(212,168,87,0.4)]" data-id="element-136">
            <CardContent className="p-7 text-center" data-id="element-137">
              <h3 className="text-2xl font-bold text-white mb-1 font-heading" data-id="element-138">
                PACK COMPLETO
              </h3>
              <p className="text-primary text-sm font-medium mb-6" data-id="element-139">
                Ebook + todos los bonos
              </p>

              {/* Pricing */}
              <div className="mb-3" data-id="element-140">
                <p className="text-white/40 line-through text-lg mb-1" data-id="element-141">
                  $89.900
                </p>
                <p className="text-4xl font-bold text-white font-heading" data-id="element-142">
                  $19.900
                </p>
              </div>

              <div className="mb-7 inline-block bg-green-500/20 text-green-400 px-3 py-1 rounded-full text-xs font-bold border border-green-500/30" data-id="element-143">
                AHORRÁS $70.000
              </div>

              {/* Includes list */}
              <div className="text-left space-y-2.5 mb-7 bg-background/40 rounded-2xl p-5 border border-border/40" data-id="element-144">
                <p className="text-xs uppercase tracking-wider text-primary font-bold mb-3 text-center" data-id="element-145">
                  Qué incluye
                </p>
                {includes.map((item, index) => <div key={index} className="flex items-start gap-2.5" data-id="element-146">
                    <div className="mt-0.5 bg-primary/20 p-0.5 rounded-full text-primary shrink-0" data-id="element-147">
                      <Check className="w-3.5 h-3.5" data-id="element-148" />
                    </div>
                    <p className="text-sm text-white/85 leading-snug" data-id="element-149">{item}</p>
                  </div>)}
              </div>

              <Button size="lg" asChild className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-bold text-base py-6 shadow-lg shadow-primary/25 active:scale-95 transition-transform rounded-2xl" data-id="element-150">
                <a href="https://checkout.librofy.online/cart/53242880491883:1" target="_blank" rel="noopener noreferrer" data-id="element-151">
                  QUIERO EL PACK COMPLETO
                </a>
              </Button>

              <p className="text-white/50 text-xs mt-4" data-id="element-152">
                Pago seguro · Acceso inmediato · Garantía 7 días
              </p>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </section>;
}